import { isNullOrUndefined } from "../../../ceres/helper/utils";
import { setUrlParam, getUrlParams, encodeParams, navigateTo } from "../../services/UrlService";

const ApiService = require("../../../ceres/services/ApiService");

const state = () => ({
	shippingCountries: [],
	shippingCountryId: null,
	euShippingCountries: []
});

const mutations = {
	setShippingCountries(state, shippingCountries) {
		state.shippingCountries = shippingCountries;
	},

	setEuShippingCountries(state, euShippingCountries) {
		state.euShippingCountries = euShippingCountries;
	},

	setShippingCountryId(state, shippingCountryId) {
		if (shippingCountryId !== state.shippingCountryId && !App.isSSR) {
			document.dispatchEvent(new CustomEvent("afterShippingCountryChanged", { detail: shippingCountryId }));
		}

		state.shippingCountryId = shippingCountryId;
	}
};

const actions = {
	selectShippingCountry({ commit, state }, { shippingCountryId, openBasketPreview, url = "", currency = "" }) {
		return new Promise((resolve, reject) => {
			const oldShippingCountryId = state.shippingCountryId;

			commit("setShippingCountryId", shippingCountryId);
			ApiService.post("/rest/io/shipping/country", { shippingCountryId: shippingCountryId })
				.done(data => {
					const urlParams = getUrlParams();

					if (url.length) {
						urlParams["ShipToCountry"] = shippingCountryId;

						if (currency.length) {
							urlParams["currency"] = currency;
						}

						if (openBasketPreview) {
							urlParams["openBasketPreview"] = 1;
						}

						navigateTo(url + "?" + encodeParams(urlParams));
					} else if (isNullOrUndefined(oldShippingCountryId) || oldShippingCountryId !== data) {
						const urlParamKeys = Object.keys(urlParams);

						if (urlParamKeys.includes("ShipToCountry")) {
							setUrlParam({ ShipToCountry: shippingCountryId });
						}

						if (openBasketPreview) {
							setUrlParam({ openBasketPreview: 1 });
						}

						window.location.reload();
					}
					resolve(data);
				})
				.fail(error => {
					commit("setShippingCountryId", oldShippingCountryId);
					reject(error);
				});
		});
	}
};

const getters = {
	getCountryName: state => countryId => {
		if (countryId > 0) {
			const country = state.shippingCountries.find(country => country.id === countryId);

			// if (isNullOrUndefined(country)) {
			// 	country = state.euShippingCountries.find(country => country.id === countryId);
			// }

			if (!isNullOrUndefined(country)) {
				return country.currLangName;
			}
		}

		return "";
	},

	getIsoCode: state => countryId => {
		if (countryId > 0) {
			const country = state.shippingCountries.find(country => country.id === countryId);

			if (!isNullOrUndefined(country)) {
				return country.isoCode2;
			}
		}

		return "";
	},

	getStateName: state => (countryId, stateId) => {
		if (countryId > 0 && stateId > 0) {
			const country = state.shippingCountries.find(country => country.id === countryId);

			if (country) {
				const state = country.states.find(countryState => countryState.id === stateId);

				return state.name;
			}
			return "";
		}
		return "";
	}
};

export default {
	state,
	mutations,
	actions,
	getters
};
